import { createContext, useContext, useState } from "react";

const ConsentCtx = createContext(null);
export const useConsent = () => useContext(ConsentCtx);

const KEY = "cs_cookie_consent";

export const ConsentProvider = ({ children }) => {
  const [consent, setConsent] = useState(() => localStorage.getItem(KEY));
  const [open, setOpen] = useState(() => !localStorage.getItem(KEY));

  const accept = () => { localStorage.setItem(KEY, "accepted"); setConsent("accepted"); setOpen(false); };
  const reject = () => { localStorage.setItem(KEY, "rejected"); setConsent("rejected"); setOpen(false); };
  const reopen = () => setOpen(true);

  return (
    <ConsentCtx.Provider value={{ consent, open, accept, reject, reopen }}>
      {children}
    </ConsentCtx.Provider>
  );
};
